import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "minus" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M20.5714 10H3.42857C2.63973 10 2 10.6397 2 11.4286V12.8571C2 13.646 2.63973 14.2857 3.42857 14.2857H20.5714C21.3603 14.2857 22 13.646 22 12.8571V11.4286C22 10.6397 21.3603 10 20.5714 10Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }